<!--  -->
<template>
  <div>
    <div class="search-row">
      <div class="search-item">
        <span class="mr5">问题类型</span>
        <el-select size="mini" clearable v-model="queryParams.type" :placeholder="`请选择`">
          <el-option v-for="item in questionType" :key="item.value" :label="item.name" :value="item.value"> </el-option>
        </el-select>
      </div>
      <div class="search-item">
        <span class="mr5">问题内容</span>
        <el-input size="mini" clearable class="input200" v-model="queryParams.search" :placeholder="`请输入`"></el-input>
      </div>
      <div>
        <el-button size="mini" type="primary" @click="search">搜索</el-button>
        <el-button size="mini" type="primary" @click="openDialog(`新增`, false)">新增</el-button>
      </div>
    </div>
    <!-- 表格 -->
    <el-table class="mt10" ref="multipleTable" border :data="list">
      <el-table-column type="index" label="#" width="55"></el-table-column>
      <el-table-column v-for="item in columns" :label="item.text" :key="item.column" :width="item.width">
        <template slot-scope="scope">
          <!-- 操作 -->
          <template v-if="item.column == 'handle'">
            <!-- 编辑 -->
            <el-button type="text" @click="openDialog(`修改`, 'isEdit', scope.row)">编辑</el-button>
            <!-- 查看 -->
            <el-button type="text" @click="openDialog(`查看`, 'check', scope.row)">查看</el-button>
            <!-- 刪除 -->
            <el-button type="text" @click="deleteData(scope.row)">删除</el-button>
          </template>
          <span class="inputClass" v-else-if="item.column == 'title'" :title="scope.row[item.column]">{{ scope.row[item.column] }}</span>
          <span v-else>{{ scope.row[item.column] }}</span>
        </template>
      </el-table-column>
    </el-table>
    <pagination :queryParams="queryParams" :getList="getList" />

    <!-- 新增和修改的弹框 -->
    <el-dialog class="rich_text" :title="dialogTitle" :visible.sync="dialogVisible" width="1200px" @close="onClose" fullscreen>
      <el-form ref="form" :disabled="dialogType == 'check'" :rules="rules" :model="form" label-width="180px">
        <el-form-item :label="`问题类型：`" prop="type">
          <el-select v-model="form.type" class="width-400" :placeholder="`请选择`">
            <el-option v-for="item in questionType" :key="item.value" :label="item.name" :value="item.value"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="`问题内容：`" prop="title">
          <el-input maxlength="30" class="width-400" v-model="form.title"></el-input>
        </el-form-item>
        <el-form-item :label="`说明内容：`" prop="content" class="editor-line">
          <tinymce ref="tinymce" :content="form.content"></tinymce>
        </el-form-item>
      </el-form>
      <div class="row-center">
        <el-button @click="closeFun">取消</el-button>
        <el-button class="ml20" :disabled="dialogType=='check'" type="primary" @click="confirm">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Pagination from '@/components/common/Pagination';
import { faqList, faqSave, faqDelete, faqDetail } from '@/api.js';
import { pageSize } from '@/utils/Config';
import tinymce from '@/components/tinymce/index';

export default {
  components: {
    Pagination,
    tinymce,
  },
  data() {
    return {
      questionType: [],
      queryParams: {
        pageIndex: 1,
        pageSize: pageSize,
        _total: 0,
      },
      form: {
        type: '',
        title: '',
        content: '',
      },
      rules: {
        type: [{ required: true, message: `请选择`, trigger: 'blur' }],
        title: [{ required: true, message: `请输入`, trigger: 'blur' }],
        content: [{ required: true, message: `请输入`, trigger: 'blur' }],
      },
      dialogType: '',
      dialogVisible: false,
      dialogTitle: `新建`,
      list: [],
      columns: [],
    };
  },
  created() {
    this.getList();
    this.getDict();
  },
  methods: {
    // 获取列表数据
    getList() {
      const { pageIndex, pageSize, type, search } = this.queryParams;
      const query = {
        page: pageIndex,
        per_page: pageSize,
        type,
        search,
      };
      this.$request('get', faqList, query).then((res) => {
        if (res) {
          this.list = res.data;
          this.columns = res.columns;
          this.queryParams._total = res.total;
        }
      });
    },

    // 搜索
    search() {
      this.queryParams.pageIndex = 1;
      this.getList();
    },

    // 关闭按钮：
    closeFun() {
      this.dialogVisible = false;
    },

    // 当弹框关闭时：
    onClose() {
      this.form = {
        type: '',
        title: '',
        content: '',
      };
      this.$refs.form.resetFields();
    },

    // 弹框里的确认
    confirm() {
      this.form.content = this.$refs.tinymce.contentData;
      this.$refs.form.validate((valid) => {
        if (valid) {
          let { type, title, content } = this.form;
          let query = {
            content,
            type,
            title,
          };
          if (this.dialogType == 'isEdit') {
            query.id = this.id;
          }
          this.$request('post', faqSave, query).then((res) => {
            if (res) {
              this.dialogVisible = false;
              this.search();
            }
          });
        } else {
          return false;
        }
      });
    },

    // 获取详情
    getDetail(id) {
      return this.$request('get', faqDetail, { id })
      .then((res) => res || {});
    },

    // 新增
    async openDialog(title, dialogType, data) {
      if (dialogType == 'isEdit' || dialogType == 'check') {
        const content = await this.getDetail(data.id);
        // 是编辑时：
        this.id = data.id;
        this.form = {
          content: content.content,
          type: content.type,
          title: content.title,
        };
        this.$nextTick(() => {
          if (dialogType == 'check') {
            // 如果是查看
            this.$refs.tinymce.readonlyFun();
          } else {
            // 如果是编辑
            this.$refs.tinymce.designFun();
          }
        });
      } else {
        if (this.$refs.tinymce) {
          this.$refs.tinymce.designFun();
        }
      }

      this.dialogVisible = true;
      this.dialogTitle = title;
      this.dialogType = dialogType;
    },

    // 删除：
    deleteData(data) {
      this.$confirm(`是否确定删除？`, `提示`, {
        confirmButtonText: `确定`,
        cancelButtonText: `取消`,
        type: 'warning',
      }).then(() => {
        this.$request('post', faqDelete, {
          id: data.id,
        }).then((res) => {
          if (res) {
            this.getList();
            this.$message({
              type: 'success',
              message: `删除成功`,
            });
          }
        });
      });
    },

    async getDict() {
      return await this.$utils.getDict([609]).then((res) => {
        this.questionType = res[609];
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.search-row {
  display: flex;
}
.search-item {
  display: flex;
  align-items: center;
  margin-right: 20px;
}
.inputClass {
  white-space: nowrap; /* 强制单行显示 */
  text-overflow: ellipsis; /* 超出部分省略号表示 */
  overflow: hidden; /* 超出部分隐藏 */
  width: auto; /* 设置显示的最大宽度 */
  cursor: pointer;
  display: inline-block; /* 转变为行内块体元素，以便设置宽度和高度 */
}
.row-center {
  text-align: center;
}
.width-400 {
  width: 400px;
}
.editor-line {
  /deep/ .el-form-item__content {
    height: 60vh;
  }
}
</style>
